import _ from 'lodash'
import { buildTransportsText, getPaymentType } from './index'
import { formatDateTime } from '../../../utils/date-format'
import { buildCell, buildHeaderCell, buildProjectName, buildReportDate } from '../report-utils'
import { formatDecimalAmount, formatMoney } from '../../../utils/number-utils'

const ExcelJS = require('exceljs')
const FileSaver = require('file-saver')

const mergeRowCells = (worksheet, colIdx, rowIdxStart, rowIdxEnd) =>
  worksheet.mergeCells(rowIdxStart, colIdx, rowIdxEnd - 1, colIdx)

const isMerged = (row, colIdx) => row.getCell(colIdx).isMerged

const buildHeader = (worksheet, start = 1) => {
  buildHeaderCell(worksheet, 'A', '№ п/п', start)
  buildHeaderCell(worksheet, 'B', 'Поставщик', start, 30)
  buildHeaderCell(worksheet, 'C', 'Заявка', start)
  buildHeaderCell(worksheet, 'D', 'Наименование', start, 40)
  buildHeaderCell(worksheet, 'E', 'Доставка', start, 30)
  buildHeaderCell(worksheet, 'F', 'Доставка с НДС', start, 10)
  buildHeaderCell(worksheet, 'G', 'Дата заявки', start, 17)
  buildHeaderCell(worksheet, 'H', 'Сумма с НДС', start, 10)
  buildHeaderCell(worksheet, 'I', 'Оплата', start, 15)
  buildHeaderCell(worksheet, 'J', 'Дата оплаты', start, 17)
  buildHeaderCell(worksheet, 'K', 'Сумма оплаты', start, 10)
  buildHeaderCell(worksheet, 'L', 'Сумма заявки с НДС', start, 10)
  buildHeaderCell(worksheet, 'M', 'Итого с НДС', start, 10)
}

const exportToXLS = async (data, project, sheetName = 'Отчет') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  buildReportDate(worksheet, 2)
  buildProjectName(worksheet, project, 4)

  const start = 6

  buildHeader(worksheet, start)

  data.reduce((nextIndex, item, index) => {
    const {
      providerRowSpan,
      appRowSpan,
      provider,
      payments,
      t,
      idx,
      appId,
      appDate,
      implName,
      implPaymentType,
      tVatSum,
      sumVat,
      appSumVat,
      totalSumVat,
    } = item

    const sheetRow = worksheet.getRow(nextIndex)

    if (providerRowSpan > 0) {
      isMerged(sheetRow, 2) && nextIndex++

      buildCell(worksheet, provider, 2, nextIndex)
      buildCell(worksheet, formatMoney(totalSumVat), 13, nextIndex)

      let maxRowsSpan = _.sum(
        data
          .slice(index, index + providerRowSpan)
          .map((row) => (row.appRowSpan > 0 ? _.max([row.payments.length, 1]) : 0))
      )

      if (maxRowsSpan > 0) {
        let maxSpan = _.max([maxRowsSpan, providerRowSpan])
        mergeRowCells(worksheet, 2, nextIndex, nextIndex + maxSpan)
        mergeRowCells(worksheet, 13, nextIndex, nextIndex + maxSpan)
      }
    }

    buildCell(worksheet, idx, 1, nextIndex)
    buildCell(worksheet, appId, 3, nextIndex)
    buildCell(worksheet, implName, 4, nextIndex)

    if (appRowSpan > 0) {
      if (t.length > 0) {
        let tr = t.length > 0 && 'Доставка: ' + buildTransportsText(t)
        buildCell(worksheet, tr, 5, nextIndex)
      }

      buildCell(worksheet, formatMoney(tVatSum), 6, nextIndex)

      payments.forEach(({ pDate, pAmount }, idx) => {
        buildCell(worksheet, formatDateTime(pDate), 10, nextIndex + idx)
        buildCell(worksheet, formatDecimalAmount(pAmount), 11, nextIndex + idx)
      })

      buildCell(worksheet, formatMoney(appSumVat), 12, nextIndex)

      mergeRowCells(worksheet, 5, nextIndex, nextIndex + appRowSpan)
      mergeRowCells(worksheet, 6, nextIndex, nextIndex + appRowSpan)
      mergeRowCells(worksheet, 12, nextIndex, nextIndex + appRowSpan)
    }

    buildCell(worksheet, formatDateTime(appDate), 7, nextIndex)
    buildCell(worksheet, formatMoney(sumVat), 8, nextIndex)
    buildCell(worksheet, getPaymentType(implPaymentType), 9, nextIndex)

    return nextIndex + 1
  }, start + 2)

  const buffer = await workbook.xlsx.writeBuffer()
  FileSaver.saveAs(new Blob([buffer]), 'result.xlsx')
}

export default exportToXLS
